<template>
    <div class="cursus-upload">
        <div class="custom-file">
            <Dropzone
                class="custom-file-input"
                :class="{ 'is-invalid': error }"
                :id="dropzoneId"
                :options="options"
                tabindex="0"
                @vdropzone-file-added="handleFileAdded"
                @vdropzone-upload-progress="handleUploadProgress"
                @vdropzone-complete="handleComplete"
                @vdropzone-sending="handleSending"
                @vdropzone-error="handleError"
                @vdropzone-success="handleSuccess"
                ref="dropzone"
            />
            <div class="custom-file-label">
                {{ label }}
            </div>
        </div>
        <template v-if="isUploading">
            <div class="progress">
                <div class="progress-bar" role="progressbar" :style="{ width: `${progress}%` }" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
        </template>
        <template v-if="error">
            <div class="invalid-feedback d-block">
                {{ error }}
            </div>
        </template>
    </div>
</template>

<script>
    import Dropzone from 'vue2-dropzone';
    import { getXsrfToken } from "../util/xhr";
    import { api } from "../api";

    export default {
        components: {
            Dropzone,
        },

        props: {
            id: String,
            uploadUrl: {
                type: String,
                required: true,
            },
            accept: {
                type: String,
                default: '.pdf,.doc,.docx,.zip,.jpg,.jpeg,.png',
            },
            maxSize: {
                type: Number,
                default: 6,
            },
            value: String,
        },

        data() {
            return {
                file: {
                    name: this.value,
                },
                isUploading: false,
                progress: null,
                error: null,
            }
        },

        computed: {
            options() {
                return {
                    url: this.uploadUrl,
                    acceptedFiles: this.accept,
                    maxFilesize: this.maxSize,
                    headers: {
                        ...api.defaults.headers,
                        'X-XSRF-TOKEN': getXsrfToken(),
                    },
                    dictFileTooBig: `Fichier trop volumineux (${this.maxSize}Mo. maximum)`,
                    dictInvalidFileType: `Extension invalide (${this.accept} acceptées)`,
                }
            },
            label() {
                return this.file?.name ?? 'Parcourir...';
            },
            dropzoneId() {
                return `${this.id}-dropzone`;
            },
        },

        methods: {
            handleFileAdded(file) {
                this.file = file;
            },
            handleError(file, data, xhr) {
                if(xhr) {
                    if(xhr.status === 422) {
                        this.error = data.errors.file?.[0];
                    } else {
                        this.error = data.message;
                    }
                } else {
                    this.error = data;
                }
            },
            handleUploadProgress(file, progress) {
                this.progress = progress;
            },
            handleSending() {
                this.isUploading = true;
                this.error = null;
            },
            handleComplete() {
                this.isUploading = false;
                this.progress = null;
            },
            handleSuccess(file, responseData) {
                this.$emit('input', responseData.data.name);
            },
            handleInputClicked() {
                // when the file input is clicked (e.g. click on form label), ensure dropzone div is focused
                this.$refs.dropzone.$el.focus();
            },
        },

        mounted() {
            const fileInput = this.$refs.dropzone.dropzone.hiddenFileInput;
            fileInput.id = this.id;
            fileInput.addEventListener('click', this.handleInputClicked);
        },
    }
</script>
